/**
 * SuggestionsList — bulleted list of general, transferable practice
 * suggestions tied to the concept gap (NOT specific to this question). The
 * default label is "Practice Going Forward" to make that scope explicit
 * versus the question-specific "Next Step for This Question". Stateless atom;
 * renders nothing when the list is empty so callers can place it
 * unconditionally.
 */
import { LatexText } from '../../latex';

interface Props {
    items: readonly string[] | undefined;
    title?: string;
}

export function SuggestionsList({ items, title = 'Practice going forward' }: Props) {
    if (!items || items.length === 0) return null;
    return (
        <section className="sol-section sol-suggestions">
            <h3 className="sol-section-title">{title}</h3>
            <ul className="sol-suggestions-list">
                {items.map((s, i) => (
                    <li key={i}><LatexText text={s} /></li>
                ))}
            </ul>
        </section>
    );
}
